export default "__VITE_ASSET__Dn8PFYIc__"